"use strict";

const CheckoutModel = require('../models/checkoutModel');

class CheckoutController extends CheckoutModel {

  constructor() {
    super();
    this.params = new URL(window.location.href).searchParams;
    this.offerId = this.params.get("offerId");
    this.bundleCode = this.params.get("bundle") || this.params.get("bundleId");
    this.promo = this.params.get("promocode") || "";
    this.tariff = this.params.get("tariff") || "";
    this.idevId = this.params.get("idev_id") || "";
  }

  init() {
    if (location.pathname.includes('checkout')) {
      this.handleRequest();
    }
  }

  handleRequest() {
    this.request(this.bundleCode, this.promo, this.tariff, this.offerId)
      .then(res => this.redirect(res));
  }

  redirect(data) {
    if (data.redirectUrl) {
      if (this.idevId) {
        log(this.idevId, 'IDEV_ID:')
        const prefix = data.redirectUrl.includes("?") ? "&" : "?";
        data.redirectUrl += `${prefix}idev_id=${this.idevId}`;
      }
      log(data.redirectUrl, 'REDIRECT_URL:')
      return window.location.replace(data.redirectUrl);
    } else {
      window.globalRedirectData = data;
    }
  }

}

module.exports = CheckoutController;
